module.exports = __webpack_public_path__ + "fonts/cbe2da8.otf";